export default "__VITE_ASSET__BobbuoAH__"